import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import partial from 'utils/partial'

export default function PagerButton(props) {
  const {active, onClick, title, value} = props
  const className = classnames('pager_button', {'is-active': active})
  const onButtonClick = onClick && partial(onClick, value)

  return (
    <div
      className={className}
      onClick={onButtonClick}
    >
      {title}
    </div>
  )
}

PagerButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./client/components/Pager/PagerButton.js